import ApplicationsAccordion from 'components/ApplicationsAccordion';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import UpdateUserForm from 'components/forms/UpdateUserForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { CARD_HEADER_DETAIL_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const UsersDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        dropdownMenuItems,
        entitiesLink,
        handleClose,
        handleEditClose,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isClosing,
        isEditing,
        isLinkedEntitiesOpen,
        isLoading,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing,
        viewedUser
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <DetailsViewPageContainer
            geometry={selectedBoundaryGeometry}
            handleClose={handleClose}
            testId={testId}>
            <DetailsViewCardHeader
                detailType={CARD_HEADER_DETAIL_TYPE}
                isDisabled={isEditing}
                isLoading={isLoading}
                items={dropdownMenuItems}
                name={`${viewedUser?.firstName} ${viewedUser?.lastName}`}
            />

            {isEditing ? (
                <UpdateUserForm
                    formValues={viewedUser}
                    isClosing={isClosing}
                    onClose={handleEditClose}
                    setIsClosing={setIsClosing}
                    userId={viewedUser?.id ?? ''}
                />
            ) : (
                <>
                    <LinkedEntitiesAccordion
                        entitiesLink={entitiesLink}
                        isOpen={isLinkedEntitiesOpen}
                        label={LINKED_ENTITIES}
                        onToggle={handleToggleLinkedEntities}
                    />

                    <ApplicationsAccordion
                        applications={applications}
                        isLoading={isApplicationsLoading}
                        isOpen={isApplicationsOpen}
                        label={APPLICATIONS}
                        onSelectApplication={handleSelectApplication}
                        onToggle={handleToggleApplications}
                        selectedApplicationId={selectedApplicationId}
                    />
                </>
            )}
        </DetailsViewPageContainer>
    );
};

export default UsersDetailsPage;
